export const animateImageToDiv = (
  imageElement: any,
  targetElement: any,
  duration = 700,
) => {
  const imageRect = imageElement.getBoundingClientRect();
  const targetRect = targetElement.getBoundingClientRect();

  // Get the current scroll positions
  const scrollX = window.scrollX || window.pageXOffset;
  const scrollY = window.scrollY || window.pageYOffset;

  imageElement.style.transition = 'all 0.26s ease-in-out';
  imageElement.style.opacity = '0.2';
  // Create a clone of the image
  const clonedImage = imageElement.cloneNode(true);
  clonedImage.style.position = 'absolute';
  clonedImage.style.left = `${imageRect.left + scrollX}px`;
  clonedImage.style.top = `${imageRect.top + scrollY}px`;
  clonedImage.style.width = `${imageRect.width}px`;
  clonedImage.style.height = `${imageRect.height}px`;
  clonedImage.style.transition = 'all 0.5s ease-in-out';
  clonedImage.style.opacity = '0.8';
  clonedImage.style.zIndex = '1000';

  // Append the cloned image to the body
  document.body.appendChild(clonedImage);

  // Animate the cloned image to the target location
  setTimeout(() => {
    clonedImage.style.left = `${targetRect.left + scrollX}px`;
    clonedImage.style.top = `${targetRect.top + scrollY}px`;
    clonedImage.style.opacity = '0.2';

    // Shrink the image
    clonedImage.style.width = '50px';
    clonedImage.style.height = '50px';
  }, 50);

  setTimeout(() => {
    imageElement.style.opacity = '1';
  }, 350);

  // Remove the cloned image after the animation
  setTimeout(() => {
    clonedImage.remove();
  }, duration);
};
